import styled from 'styled-components';

export const Container = styled.div`
    margin: 0 auto;
    width: 95%;
    color: #393939;

    .alert{
        width: 100%;
        color: red;
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        font-size: 18px;

        svg{
            cursor: pointer;
        }
    }
`;

export const Label = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    strong{
        font-weight: 500;
        font-size: 1.2rem;
        margin-right: 5px;
    }

    svg{
        cursor: pointer;
    }
`;

export const ContainerInput = styled.div`
    width: 100%;
    height: 40px;
    border: 1px solid #7A05A7;
    border-radius: 5px;
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    input{
        width: 100%;
        border: none;
        font-size: 18px;
        padding: 0 5px;
        color: #7A05A7;

    }

    .inputBusiness{
        width: 95%;
    }
`;

export const Button = styled.button`
    width: 100%;
    height: 40px;
    background-color: #7A05A7;
    border: 0;
    border-radius: 5px;
    color: #fff;
    font-size: 18px;
    margin-top: 10px;
`;